import { lazy } from 'react';

export const SettingsOrdersSourcingAsync = lazy(
    () => import('./SettingsOrdersSourcing'),
);
